import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { agrogestao } from "@/api/agrogestaoClient";
import MovimentacaoGraoForm from "@/components/armazens/MovimentacaoGraoForm";
import { Loader2, ArrowLeft, PencilLine } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function MovimentacaoGraoNova() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const movementId = searchParams.get('id');
    const isEditing = !!movementId;

    const propriedadeId = localStorage.getItem("propriedade_selecionada");

    const { data: initialData, isLoading: loadingMovement } = useQuery({
        queryKey: ['movimentacao_grao', movementId],
        queryFn: () => movementId ? agrogestao.entities.MovimentacaoGrao.get(movementId) : Promise.resolve(null),
        enabled: isEditing
    });

    const { data: armazens = [], isLoading: loadingArmazens } = useQuery({
        queryKey: ['armazens', propriedadeId],
        queryFn: () => propriedadeId
            ? agrogestao.entities.Armazem.filter({ propriedade_id: propriedadeId })
            : Promise.resolve([]),
        enabled: !!propriedadeId
    });

    const { data: estoques = [] } = useQuery({
        queryKey: ['estoques_grao', propriedadeId],
        queryFn: () => propriedadeId
            ? agrogestao.entities.EstoqueGrao.filter({ propriedade_id: propriedadeId })
            : Promise.resolve([]),
        enabled: !!propriedadeId
    });

    const { data: safras = [] } = useQuery({
        queryKey: ['safras', propriedadeId],
        queryFn: () => propriedadeId
            ? agrogestao.entities.Safra.filter({ propriedade_id: propriedadeId })
            : Promise.resolve([]),
        enabled: !!propriedadeId
    });

    if (loadingArmazens || loadingMovement) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-stone-50">
                <Loader2 className="w-8 h-8 text-[#1B4332] animate-spin" />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-stone-50 flex flex-col">
            {/* Header / Toolbar */}
            <div className="bg-white border-b border-stone-200 px-6 py-4 flex items-center justify-between sticky top-0 z-20">
                <div className="flex items-center gap-4">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => navigate('/ArmazensGraos')}
                        className="text-stone-500 hover:text-[#1B4332]"
                    >
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Voltar
                    </Button>
                    <div className="h-6 w-px bg-stone-200" />
                    <h1 className="text-lg font-bold text-stone-900 flex items-center gap-2">
                        {isEditing ? (
                            <>
                                <PencilLine className="w-5 h-5 text-amber-600" />
                                Editar Movimentação de Grãos
                            </>
                        ) : (
                            "Nova Movimentação de Grãos"
                        )}
                    </h1>
                </div>
            </div>

            {/* Form Container */}
            <div className="flex-1 overflow-hidden">
                <MovimentacaoGraoForm
                    initialData={initialData}
                    armazens={armazens}
                    estoques={estoques}
                    safras={safras}
                    onSuccess={() => navigate('/ArmazensGraos')}
                    onCancel={() => navigate('/ArmazensGraos')}
                />
            </div>
        </div>
    );
}
